import moment from 'moment';

export default function toDate(date: any | Date, format = 'DD/MM/YYYY') {
  if (date) {
    if (typeof date === 'string' && date.includes('/')) return date;

    return moment(date).utc().format(format);
  }

  return null;
}
